module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Year of Biblical Womanhood")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctmi",
    staticStyle: {
      "margin-top": "10%"
    },
    attrs: {
      "id": "p0013-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter3#c1",
      "id": "cc1"
    }
  }, [_c('b', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "color": "#cecece",
      "border": "thick solid"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txl",
    attrs: {
      "id": "p0013-02-1"
    }
  }, [_c('span', [_c('i', [_vm._v("Does not the very nature of things teach you that if a man has long hair, it is a disgrace to him, but that if a woman has long hair, it is her glory?")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-03-3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("1")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS")]), _vm._v(" 11:14–15 "), _c('br'), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx0",
    attrs: {
      "id": "p0013-04-4"
    }
  }, [_c('span', [_c('b', [_vm._v("I ")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("STARED BACK AT MYSELF IN THE SALON MIRROR, WONDER")]), _vm._v("ing whatever happened to the woman who sat in this same hydraulic chair just a year ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-05-6"
    }
  }, [_c('span', [_vm._v("After 368 days without a haircut, I looked like a character from "), _c('i', [_vm._v("Willow")]), _vm._v(", or more precisely, a character from "), _c('i', [_vm._v("Willow ")]), _vm._v("in the process of getting eaten by a character from "), _c('i', [_vm._v("Spinal Tap")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781595553676_INT_0013_006.jpg",
      "id": "p0013-d6e70",
      "src": "images/9781595553676_INT_0013_006.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_vm._v("I’d also gained thirteen pounds, developed a mild addiction to unleavened bread, turned thirty, and settled far too comfortably into a dress code of oversized T-shirts and peasant skirts.")])])]), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-2"
    }
  }, [_c('span', [_vm._v("A pretty, blond stylist stood over me, running her fingers through my monster hair, her nails catching in its mousy-brown tangles. “And what can I do for you today?” she asked with a sweet, East Tennessee twang that I could only assume masked her abject horror at the scene.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-03-4"
    }
  }, [_c('span', [_vm._v("“Well, it’s been a year since my last haircut,” I said. “And as you can see, my hair’s a little too thick to grow out without some . . . consequences. So, I guess I just want you to, you know, fix it. Maybe take five or six inches off?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-04-6"
    }
  }, [_c('span', [_vm._v("“Now, why in the world would you go a year without cutting your hair?” the stylist asked with a playful laugh, totally unfazed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-05-8"
    }
  }, [_c('span', [_vm._v("“Why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-06-10"
    }
  }, [_c('span', [_vm._v("It was the question people asked each time I pulled a scarf over my head to pray or addressed my husband as “master,” the question they asked after I spent an afternoon perched on my rooftop, adopted a computer-baby, camped out in my front yard during my period, and left eight pounds of dough to rise in my bathroom. It was the question they asked when they wondered what brought me to an Amish schoolhouse in Gap, Pennsylvania; a pig farm in Cochabamba, Bolivia; and a Benedictine monastery in Cullman, Alabama; or what inspired a thoroughly liberated and domestically challenged woman like me to suddenly take up baking and knitting and needlework.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-07-12"
    }
  }, [_c('span', [_vm._v("I wasn’t sure how to explain to my unsuspecting hairstylist that the reason I hadn’t cut my hair in a year was because two thousand years ago, a Jewish tentmaker wrote a letter to his friends in the city of Corinth in which he mentioned that “if a woman has long hair, it is her glory” (1 Corinthians 11:15).")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-08-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_c('span', [_vm._v("But because small-town hair salons represent the last remaining vestiges of a storytelling culture, and because you can’t exactly make a run for it once someone’s wrapped you in a plastic cape and ")])]), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_vm._v(" clamped a dozen butterfly clips in your hair, I figured I might as well start from the beginning.")])]), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-2"
    }
  }, [_c('span', [_vm._v("So, over the roar of hair dryers and the prattle of gossip, as little clumps of my “glory” fell to the floor, I told her about my year of biblical womanhood . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781595553676_INT_0015_003.jpg",
      "id": "p0015-d6e28",
      "src": "images/9781595553676_INT_0015_003.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx0",
    attrs: {
      "id": "p0015-04-4"
    }
  }, [_c('span', [_vm._v("My husband, Dan, and I had a long-standing agreement that we would start a family as soon as we became independently wealthy or I turned thirty, whichever happened first. This arrangement suited me just fine until my twenty-ninth birthday, which happened on June 8, 2010, four months before this experiment of mine began.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-6"
    }
  }, [_c('span', [_vm._v("It was a few days after my birthday that I sat on a living room floor crowded with toddlers, wrapping paper, inflated balloons, and deflated moms, wondering to myself if this was it—my last year of freedom. A teary young mom had just recounted in excruciating detail the suspicious contents of her two-year-old’s diaper, when, as always seems to happen after a group of moms exchanges horror stories about parenting, someone asked in that familiar, cajoling voice, “So when can we expect a baby from you, Rachel?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-06-8"
    }
  }, [_c('span', [_vm._v("I’ve come to welcome this question as a compliment, an invitation of sorts. But pushing thirty left me with fewer acceptable responses, and the truth—that I’m absolutely, inexplicably terrified of motherhood—was too embarrassing to speak aloud. It crossed my mind that I could get away with a lie. You know: shrug my shoulders, conjure up some tears, and say something about God’s perfect timing to imply that we were trying, because, really, who’s going to conduct a thorough investigation into that? But instead I found myself saying, “I think I’d like to write another book first,” which came across a lot more smugly than I intended.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-07-10"
    }
  }, [_c('span', [_vm._v("Dan certainly wasn’t pushing parenthood. He’s the kind of guy who values efficiency above all else, and after seven years of marriage, our two-person family unit moved through the world like a SWAT team. We communicated mostly in code and with hand motions, tackling everything from chores to road trips to our two home businesses as a highly organized team. Tasks were silently assigned to whoever could finish them first, so we wasted little time talking about division of labor or “roles.” When it was time for dinner, someone made it. When the money dried up, someone took on another client. When the sponge next to the kitchen sink started to smell like death, Dan threw it out.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-2"
    }
  }, [_c('span', [_vm._v("We’d seen what a few diaper bags and car seats could do to this situation, so whenever I brought up the issue of children, Dan shrugged his shoulders and said, “We’re in no hurry.” I’d quickly agree and then change the subject, pretending that the rhythmic gonging reverberating throughout my entire body was something other than my biological clock going ballistic on me.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-03-4"
    }
  }, [_c('span', [_vm._v("But it wasn’t just my friends pushing procreation; it was my church.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-04-6"
    }
  }, [_c('span', [_vm._v("I was raised evangelical, which means I spent a good part of my life feeling sorry for the rest of humanity on account of its certain destiny in hell. This was not something my parents taught me directly, just something I picked up from preachers, Sunday school teachers, and Christian playmates along the way. After hearing time and again that “wide is the path that leads to destruction,” I just assumed that Buddhists went to hell for worshipping Buddha, Catholics went to hell for worshipping Mary, and Al Gore went to hell for worshipping nature. I didn’t even think to have a faith crisis about it until college.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-05-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_c('span', [_vm._v("The first time I saw Joyce Meyer preaching on TV, I figured she was going to hell too. I was about nine years old at the time, and I remember she wore a fuchsia suit, a short haircut, and massive gold earrings. Pacing back and forth on the stage, with a microphone in one hand and a Bible in the other, Joyce spoke with a conviction and urgency I’d never witnessed before. Her confidence frightened me. I wondered how she could be so brazen in the midst of her sin, how she could go on speaking about “the favor of our Lord,” when ")])]), _c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_vm._v(" everyone knows ladies aren’t supposed to preach from the Word of God. According to my Sunday school teacher, that was a job the Bible reserved for men.")])]), _c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-2"
    }
  }, [_c('span', [_vm._v("By that time, I’d received a lot of mixed messages about the appropriate roles of women in the home, the church, and society, each punctuated with the claim that it was God’s perfect will that all women everywhere do this or that. In my world, women like Joyce Meyer were considered heretics for preaching from the pulpit in violation of the apostle Paul’s restriction in 1 Timothy 2:12 (“I do not permit a woman to teach or to have authority over a man; she must be silent”), while conservative Mennonites were considered legalistic for covering their heads in compliance with his instructions in 1 Corinthians 11:5 (“Every woman who prays or prophesies with her head uncovered dishonors her head”). Pastors told wives to submit to their husbands as the apostle Peter instructed in 1 Peter 3:1, but rarely told them to refer to their husbands as “master” as he instructed just three sentences later in 1 Peter 3:6. By the time I was twelve, I learned I could single-handedly ruin a boy’s relationship with God by the length of my skirt or the cut of my blouse (Matthew 5:27–28), but that good looks and pretty clothes weren’t all bad, because that’s how Queen Esther saved the Jews.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-03-4"
    }
  }, [_c('span', [_vm._v("According to James Dobson, women weren’t inferior to men, just created for different roles. Our ultimate calling, he said, is in the home, where we can serve God and our husbands by keeping things clean, having supper on the table at six, and, most important, making babies.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-04-6"
    }
  }, [_c('span', [_vm._v("In my own home, little was said about gender roles or hierarchy. Submission was something my mom did once in 1976, not something she did every day. (More about that later.) A freethinker in a stridently traditional religious culture, Mom often came home from church overwhelmed with yet another casserole to make, nursery to keep, or wedding shower to plan. “The only people who enjoy potlucks are men,” she used to say. “The women do all the work.”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-05-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_c('span', [_vm._v("Despite her aversion to covered dishes, Mom never complained ")])]), _c('a', {
    attrs: {
      "id": "pagexviii"
    }
  }, [_vm._v(" about her roles as a wife and mother, though she took a hiatus from her career as a schoolteacher to stay home with us when we were little. Smart, compassionate, and funny, she protected my sister and me from the pockets of legalism that surrounded us and told us we could be anything we wanted to be when we grew up, no matter what anyone said. She and my father both loved the Bible, but they seemed to know instinctively that rules that left people guilt-ridden, exhausted, and confused were not really from God. I think this is one of the reasons why, despite the fact that I vote for Democrats, believe in evolution, and am no longer convinced that everyone different from me goes to hell, I don’t mind being identified as an evangelical Christian. Evangelicalism is like my religious mother tongue. I revert to it whenever I’m angry or excited or surrounded by other people who understand what I’m saying. And it’s the language in which I most often hear God’s voice on the rare occasion that it rises above the noise.")])]), _c('a', {
    attrs: {
      "id": "pagexviii"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-2"
    }
  }, [_c('span', [_vm._v("My first encounter with “biblical womanhood” happened in college, when there were whispers around the dormitory about whether God wanted young ladies at a Christian university to run for student body president. Apparently, there were rules about such things, rules that the apostle Paul wrote down in a letter to Timothy approximately two millennia ago. Rumor had it that biblical womanhood required stepping aside to allow godly men to take the lead. This sparked a few late-night dorm room debates, as some of my classmates argued that those instructions applied only in a church setting while others noted that there weren’t a lot of godly men beating down the doors to plan our banquets and pep rallies that year. If I remember correctly, the point became moot when a woman ran uncontested.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-03-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexviii"
    }
  }, [_c('span', [_vm._v("Over the next few years, I found myself drawn into more and more of these conversations, especially as my girlfriends and I began getting married and starting families of our own. Many were influenced by evangelical complementarianism, a movement that began as a reaction to second-wave feminism and found some of its first ")])]), _c('a', {
    attrs: {
      "id": "pagexix"
    }
  }, [_vm._v(" expressions in the writings of Edith Schaeffer ("), _c('i', [_vm._v("The Hidden Art of Homemaking")]), _vm._v(", 1971) and Elisabeth Elliot ("), _c('i', [_vm._v("Let Me Be a Woman")]), _vm._v(", 1976). Hailed as model wives and homemakers, these women are highly esteemed in the Reformed tradition, where the oft-repeated saying is “As many people were brought to the Lord through Mrs. Schaeffer’s cinnamon buns as through Dr. Schaeffer’s sermons.” But behind the winsome prose lies an uncompromising conviction: the virtuous woman serves primarily from the home as a submissive wife, diligent homemaker, and loving mother.")])]), _c('a', {
    attrs: {
      "id": "pagexix"
    }
  }), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexix"
    }
  }, [_c('span', [_vm._v("“This is a woman’s place,” says Elliot, “and all of us need to know what our place is and to be put in it. The command of God puts us there where we belong.”")])]), _c('span', {
    attrs: {
      "href": "#/chapter31#imm1",
      "id": "im1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-03-3"
    }
  }, [_c('span', [_vm._v("The theological bulwark of the movement can be found in the Council for Biblical Manhood and Womanhood. Led by conservative pastor John Piper and theologian Wayne Grudem, the CBMW produced two pivotal documents that extended the influence of the movement beyond the confines of the Reformed tradition: “The Danvers Statement” (published in 1988) and "), _c('i', [_vm._v("Recovering Biblical Manhood and Womanhood ")]), _vm._v("(published first in 1991 and again in 2006). The CBMW enjoyed a resounding victory when, influenced by the Danvers Statement, representatives from the sixteen-million-member Southern Baptist Convention voted to amend their statement of belief to include a declaration on family life, noting that a woman should “submit herself graciously” to her husband’s leadership."), _c('span', {
    attrs: {
      "href": "#/chapter31#imm2",
      "id": "im2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-04-4"
    }
  }, [_c('span', [_vm._v("According to the Danvers Statement, the acceptance of feminist ideology among Christians has led to a “threat to Biblical authority as the clarity of Scripture is jeopardized and the accessibility of its meaning to ordinary people is withdrawn into the restricted realm of technical ingenuity.” The statement says that rather than following the prevailing culture, women of God should pursue “biblical womanhood.”"), _c('span', {
    attrs: {
      "href": "#/chapter31#imm3",
      "id": "im3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-05-5"
    }
  }, [_c('span', [_vm._v("Now, we evangelicals have a nasty habit of throwing the word "), _c('i', [_vm._v("biblical ")]), _vm._v("around like it’s Martin Luther’s middle name. We especially like "), _c('a', {
    attrs: {
      "id": "pagexx"
    }
  }, [_vm._v("to stick it in front of other loaded words, like "), _c('i', [_vm._v("economics, sexuality, politics")]), _vm._v(", and "), _c('i', [_vm._v("marriage")]), _vm._v(" to create the impression that God has definitive opinions about such things, opinions that just so happen to correspond with our own. Despite insistent claims that we don’t “pick and choose” what parts of the Bible we take seriously, using the word "), _c('i', [_vm._v("biblical")]), _vm._v(" prescriptively like this almost always involves selectivity.")])])]), _c('a', {
    attrs: {
      "id": "pagexx"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-02-2"
    }
  }, [_c('span', [_vm._v("After all, technically speaking, it is "), _c('i', [_vm._v("biblical")]), _vm._v(" for a woman to be sold by her father (Exodus 21:7), "), _c('i', [_vm._v("biblical")]), _vm._v(" for her to be forced to marry her rapist (Deuteronomy 22:28–29), "), _c('i', [_vm._v("biblical")]), _vm._v(" for her to remain silent in church (1 Corinthians 14:34–35), "), _c('i', [_vm._v("biblical")]), _vm._v(" for her to cover her head (1 Corinthians 11:6), and "), _c('i', [_vm._v("biblical")]), _vm._v(" for her to be one of multiple wives (Exodus 21:10).")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-03-4"
    }
  }, [_c('span', [_vm._v("This is why the notion of “"), _c('i', [_vm._v("biblical")]), _vm._v(" womanhood” so intrigued me. Could an ancient collection of sacred texts, spanning multiple genres and assembled over thousands of years in cultures very different from our own, really offer a single cohesive formula for how to be a woman? And do all the women of Scripture fit into this same mold? Must I?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-04-6"
    }
  }, [_c('span', [_vm._v("I’m the sort of person who likes to identify the things that most terrify and intrigue me in this world and plunge headlong into them like Alice down the rabbit hole. This is the reason I have trouble making small talk and sitting still, and it’s the reason I woke up one morning with a crazy idea lighting up every corner of my brain.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-05-8"
    }
  }, [_c('span', [_c('i', [_vm._v("What if I tried it all? What if I took “biblical womanhood” literally?")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781595553676_INT_0020_006.jpg",
      "id": "p0020-d6e134",
      "src": "images/9781595553676_INT_0020_006.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx0",
    attrs: {
      "id": "p0020-07-10"
    }
  }, [_c('span', [_vm._v("As it turns out, there are publishers out there who will actually pay for you to jump down rabbit holes, so long as they believe said rabbit holes are marketable to the general public. So on October 1, 2010, with the support of Dan and a brave team of publishing professionals, I vowed to spend one year of my life in pursuit of "), _c('i', [_vm._v("true")]), _vm._v(" biblical womanhood.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-08-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexx"
    }
  }, [_c('span', [_vm._v("This quest of mine required that I study every passage of Scripture ")])]), _c('a', {
    attrs: {
      "id": "pagexxi"
    }
  }, [_vm._v("that relates to women and learn how women around the world interpret and apply these passages to their lives. In addition, I would attempt to follow as many of the Bible’s teachings regarding women as possible in my day-to-day life, sometimes taking them to their literal extreme.")])]), _c('a', {
    attrs: {
      "id": "pagexxi"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-2"
    }
  }, [_c('span', [_vm._v("From the Old Testament to the New Testament, from Genesis to Revelation, from the Levitical code to the letters of Paul, there would be no picking and choosing. A year of biblical womanhood would mean, among other things, rising before dawn (Proverbs 31:15), submitting to my husband (Colossians 3:18), growing out my hair (1 Corinthians 11:15), making my own clothes (Proverbs 31:21–22), learning how to cook (Proverbs 31:15), covering my head in prayer (1 Corinthians 11:5), calling Dan “master” (1 Peter 3:5–6), caring for the poor (Proverbs 31:20), nurturing a gentle and quiet spirit (1 Peter 3:4), and remaining ceremonially impure for the duration of my period (Leviticus 15:19–33).")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-03-4"
    }
  }, [_c('span', [_vm._v("Some practices I would observe just once. Others I would try to observe all year. Each month I would focus on a different virtue—gentleness, domesticity, obedience, valor, beauty, modesty, purity, fertility, submission, justice, silence, and grace.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-04-6"
    }
  }, [_c('span', [_vm._v("Throughout the year, my “Biblical Woman’s Ten Commandments” would serve as a guide for daily living:"), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0021-05-8"
    }
  }, [_c('span', [_vm._v("1. Thou shalt submit to thy husband’s will in all things. (Genesis 3:16; Titus 2:5; 1 Peter 3:1; Ephesians 5:22; 1 Corinthians 11:3; Colossians 3:18)")])]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0021-P-1"
    }
  }, [_c('span', [_vm._v("2. Thou shalt devote thyself to the duties of the home. (Proverbs 14:1; 31:10–31; 1 Timothy 5:14; Titus 2:4–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0021-P-2"
    }
  }, [_c('span', [_vm._v("3. Thou shalt mother. (Genesis 1:28; Psalm 128:3; 1 Timothy 5:14)")])]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0021-P-3"
    }
  }, [_c('span', [_vm._v("4. Thou shalt nurture a gentle and quiet spirit. (1 Peter 3:3– 4; Titus 2:3–5; 1 Timothy 3:11)")])]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0021-P-4"
    }
  }, [_c('span', [_vm._v("5. Thou shalt dress modestly. (Genesis 24:65; Deuteronomy 22:5; 1 Timothy 2:8–10; 1 Peter 3:3)")])])]), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0022-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexxi"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "pagexxii"
    }
  }, [_vm._v("6. Thou shalt cover thy head when in prayer. (1 Corinthians 11:3–16)")])]), _c('a', {
    attrs: {
      "id": "pagexxii"
    }
  }, [_c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0022-P-1"
    }
  }, [_c('span', [_vm._v("7. Thou shalt not cut thy hair. (1 Corinthians 11:15)")])]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0022-P-2"
    }
  }, [_c('span', [_vm._v("8. Thou shalt not teach in church. (1 Corinthians 14:33–35; 1 Timothy 2:12)")])]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0022-P-3"
    }
  }, [_c('span', [_vm._v("9. Thou shalt not gossip. (Numbers 12:1–10; Proverbs 26:20; 1 Timothy 5:13–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0022-P-4"
    }
  }, [_c('span', [_vm._v("10. Thou shalt not have authority over a man. (1 Timothy 2:12)"), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-1"
    }
  }, [_c('span', [_vm._v("I took my research way too seriously, combing through feminist, conservative, and liberal commentaries, and seeking out Jewish, Catholic, and Protestant perspectives on each issue. I spoke with modern-day women practicing ancient biblical mandates in their own lives—a polygamist, a pastor, a Quiverfull daughter, an Orthodox Jew, an Amish grandmother. I scoured the Bible, cover to cover, isolating and examining every verse I could find about mothers, daughters, widows, wives, concubines, queens, prophetesses, and prostitutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-03-3"
    }
  }, [_c('span', [_vm._v("Within a couple of weeks of starting the experiment, I was annoying my friends with random facts about biblical womanhood.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-P-5"
    }
  }, [_c('span', [_vm._v("Take Proverbs 31, for example. As it turns out, we have a woman to thank for the ancient acrostic poem that outlines in excruciating detail the daily activities of an excellent wife, perpetuating a three-thousand-year-old inferiority complex among just about every woman in the Judeo-Christian tradition. The poem is recorded in the Bible by King Lemuel as “an oracle his mother taught him” ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("V")]), _vm._v(". 1 ), a fact that totally upset my plan to cast the Proverbs 31 woman as an unrealistic archetype of the misogynistic imagination.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-04-5"
    }
  }, [_c('span', [_vm._v("The Proverbs 31 woman rises before the sun each day, plans every meal, strengthens her arms, goes to the market, brings home exotic foods, runs a profitable business, dresses her husband and children, invests in real estate, cares for the poor, compliments her husband, spends hours at the loom, and burns the midnight oil, before starting it all over again the next day.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexxii"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "pagexxiii"
    }
  }, [_vm._v("This, according to the oracle, is what a man should look for in a wife, which of course leads me to believe that King Lemuel’s mom was the kind who didn’t actually want a daughter-in-law. (Add a shrug of the shoulders and the accent of a Jewish grandmother to “A wife of noble character who can find?” and you get what I mean.)")])]), _c('a', {
    attrs: {
      "id": "pagexxiii"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-02-1"
    }
  }, [_c('span', [_vm._v("However, as the leaves began to turn and day 1 of the year of biblical womanhood loomed before me, I found myself inexplicably drawn to Proverbs 31:25: “She is clothed with strength and dignity; she can laugh at the days to come.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-03-3"
    }
  }, [_c('span', [_vm._v("I was pretty sure I couldn’t find “strength” or “dignity” in the women’s section at Kohl’s, but when I considered the sheer absurdity of someone like me doing something like this, the best I could do was laugh at the days to come. And there was something strangely liberating about that.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6061275e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 81
// module chunks = 0